module.exports = __webpack_public_path__ + "img/close-icon.e213e9cf.svg";